import {
  PrismicDataByTag,
  PrismicDocumentType,
  PrismicFragmentType,
} from '@/constants/prismicContent';

class PrismicRequestsHelper {
  constructor(prismicInstance) {
    this.prismicInstance = prismicInstance;
  }

  getDocument(tag) {
    const { documentType } = PrismicDataByTag[tag];

    switch (documentType) {
      case PrismicDocumentType.Single:
        return this.#getSingleDocument(tag);
      case PrismicDocumentType.Repeatable:
        return this.#getRepeatableDocument(tag);
      default:
        return null;
    }
  }

  async #getSingleDocument(tag) {
    const { layoutType } = PrismicDataByTag[tag];
    const { data } = await this.prismicInstance.client.getSingle(layoutType);

    return data;
  }

  async #getRepeatableDocument(tag) {
    const { layoutType } = PrismicDataByTag[tag];

    const response = await this.prismicInstance.client.query([
      this.prismicInstance.Predicates.at(
        PrismicFragmentType.DocumentType,
        layoutType,
      ),
      this.prismicInstance.Predicates.at(
        PrismicFragmentType.DocumentTags,
        [tag],
      ),
    ]);

    const [{ data }] = response.results;

    return data;
  }
}

export default PrismicRequestsHelper;
